import { api, type QuizResult } from "../api/client.js";
import { shell } from "../ui/layout.js";
import { escapeHtml } from "../ui/dom.js";
import type { Quiz } from "../quiz/scoring.js";

const loaded = import.meta.glob("../content/quizzes/*.json", { eager: true });
const quizzes: Quiz[] = Object.values(loaded).map((m) => (m as { default: Quiz }).default);

export async function resultsPage(root: HTMLElement): Promise<void> {
  const content = await shell(root, "results");
  content.innerHTML = `
    <h1>Results</h1>
    <label>Quiz
      <select id="quizsel">
        ${quizzes.map((q) => `<option value="${escapeHtml(q.id)}">${escapeHtml(q.title)}</option>`).join("")}
      </select>
    </label>
    <div id="resultsbody" style="margin-top:1rem">Select a quiz.</div>`;

  const sel = content.querySelector<HTMLSelectElement>("#quizsel");
  const body = content.querySelector<HTMLElement>("#resultsbody");
  if (!sel || !body) return;

  const load = async (): Promise<void> => {
    body.textContent = "Loading…";
    try {
      renderTable(body, await api.results(sel.value));
    } catch (e) {
      const msg = e instanceof Error ? e.message : "";
      body.textContent = msg.includes("403")
        ? "You are not authorized to view results."
        : "Could not load results.";
    }
  };

  sel.addEventListener("change", () => {
    void load();
  });
  if (quizzes.length) await load();
}

function renderTable(body: HTMLElement, rows: QuizResult[]): void {
  if (!rows.length) {
    body.textContent = "No attempts yet.";
    return;
  }
  const sorted = [...rows].sort((a, b) => b.submitted_at.localeCompare(a.submitted_at));
  body.innerHTML = `
    <table class="tbl">
      <thead><tr><th>When</th><th>Email</th><th>Score</th><th>%</th></tr></thead>
      <tbody>
        ${sorted
          .map(
            (r) => `
          <tr>
            <td>${new Date(r.submitted_at).toLocaleString()}</td>
            <td>${escapeHtml(r.email)}</td>
            <td>${r.score}/${r.total}</td>
            <td>${r.percentage}%</td>
          </tr>`,
          )
          .join("")}
      </tbody>
    </table>`;
}
